import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ArrowButton from './button-arrow';

import './link-button.css';

// A router Link wrapping an ArrowButton. ArrowButton's `Can` guard renders a block <div>,
// which would otherwise stretch the anchor to full width and make the whole row clickable
// (not just the button). `.link-button` shrinks the anchor to its content so only the button
// is clickable. Pass `block` for an intentionally full-width button — the anchor then spans
// it, which is the correct behaviour there.
//
// Use this instead of hand-wrapping <Link><ArrowButton/></Link> so the click-area fix is
// applied consistently to every "Add"/action button (IGN-2351).
const LinkButton = ({
  to, block = false, linkClassName, children, ...arrowProps
}) => (
  <Link
    to={to}
    className={classnames('link-button', { 'link-button--block': block }, linkClassName)}
  >
    <ArrowButton block={block} {...arrowProps}>
      {children}
    </ArrowButton>
  </Link>
);

LinkButton.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  block: PropTypes.bool,
  linkClassName: PropTypes.string,
  children: PropTypes.node,
};

export default LinkButton;
